import React, { useState } from 'react';
import { Box, Container, createStyles, Dialog, Grid, IconButton, makeStyles, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Theme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { Add, Search } from '@material-ui/icons';
import AgregarFacturador from './AgregarFacturador';
import useCommonApi from '../../api/useCommonApi';
import { ICliente } from '../../entities/catalogos/ICliente';
import LoadingDialog from '../../components/controls/LoadingDialog';
import CloseIcon from '@material-ui/icons/Close';
import { IHelp } from '../help/Help';
import swal from 'sweetalert2';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';



interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
    setFacturador: (facturador: any) => void
    ayuda: IHelp,
    idCliente: number
    usuario: string
    empresaId: number
}



interface ClienteFacturador {
    id: number,
    nombre: string,
    rfc: any
}


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
            textTransform: "uppercase"
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px"
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
    }),
);


const BuscarFacturador = ({ abierto, cerrar, confirmar, maxWidth, setFacturador, ayuda, idCliente, usuario, empresaId }: Props) => {

    const classes = useStyles();
    const apiSource = useCommonApi();
    const [selectedValue, setSelectedValue] = useState(0);
    const [buscarRFC, setRFC] = useState(null);
    const [showLoading, setLoading] = useState(false);
    const [clienteId, setClienteId] = useState(0);
    const [clienteNombre, setClienteNombre] = useState('');
    const [nombreComercial, setNombreComercial] = useState('');
    const [clienteRFC, setClienteRFC] = useState(null);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedValue(Number(event.target.value));
    };
    const [agregaFacturador, setAgregarFacturador] = useState(false);
    const agregarFacturador = () => {
        setAgregarFacturador(true);
    };

    const cerrarNuevoFacturador = () => {
        setAgregarFacturador(false);
    };


    const getClienteRFC = async () => {
        const result = await apiSource.obtenerAsync<ICliente>("cliente/by-rfc?rfc=" + buscarRFC);
        return result;
    };

    const selectFacturador = () => {

        validaCliente(clienteId).then(result => {
            if (result == 0) {
                swal.fire({
                    titleText: traducirMessage(11), //'¡Aviso!',
                    text: traducirMessage(48), //"EL CLIENTE NO TIENE ACTUALIZADOS SUS DATOS FISCALES PARA LA EMISIÓN DEL CFDI 4.0. FAVOR DE CONTACTAR A SU EJECUTIVO DE CUENTA O AL ÁREA DE SERVICIO AL CLIENTE.",
                    type: 'warning',
                });


            }
            else {
                let cliente = {
                    id: clienteId,
                    clienteNombre: clienteNombre,
                    clienteRFC: clienteRFC
                };
                setFacturador(cliente);
                confirmar();
            }
        });



    };

    const validaCliente = async (cliente) => {
        let params = {
            clienteId: cliente.toString(),
            modulo: traducirMessage(274), //"SOLICITUD SERVICIO EXTERNO NUEVO",
            evento: traducirMessage(275), //"BUSCAR FACTURADOR",
            username: localStorage.getItem("usuario_nombre")
        };
        const result = await apiSource.postAsync<number>("solicitud-servicio/valida-cliente-datos-cFDI", params);
        return result;
    }

    const handleChangeRFC = (event) => {
        setRFC(event.target.value);
    };

    const buscarCliente = () => {
        setLoading(true);
        getClienteRFC().then(data => {


            if (data.id !== null) {
                setClienteRFC(buscarRFC);
                setClienteId(data.id);
                setClienteNombre(data.nombre);
                setNombreComercial(data.nombreComercial ?? "");
                setSelectedValue(data.id);
            }

            setLoading(false);
        }).catch(error => {
            setLoading(false);

        });
    }
    const getFacturador = (cliente: any) => {
        setFacturador(cliente);
        setRFC(cliente.clienteRFC);
        buscarCliente();
    }



    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "md"} fullWidth={true} onClose={cerrar} style={{ zIndex: 1000 }}>
            <DialogTitle id="simple-dialog-title" >
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1}>
                        {/* Facturador */
                            traducirLabel(127)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>



            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>
                    <Container maxWidth="xl" className={classes.principal} >

                        <Grid container spacing={3} className={classes.container}>
                            <Grid item xs={12}>
                                <div className={classes.label}>
                                    {/* RFC */
                                        traducirLabel(268)}
                                </div>
                            </Grid>
                            <Grid item xs={10}>
                                <div className={classes.div_rfc}>
                                    <form className={classes.root} noValidate autoComplete="off">
                                        <TextField id="outlined-basic" className={classes.text}
                                            value={buscarRFC}
                                            onChange={handleChangeRFC}
                                            variant="outlined" fullWidth
                                            inputProps={{ maxLength: 13 }} />
                                    </form>

                                </div>
                            </Grid>
                            <Grid item xs={1}>
                                <Button className={classes.icon} color="primary" onClick={() => buscarCliente()}>
                                    <Search />
                                </Button>
                            </Grid>
                            <Grid item xs={1}>
                                <Button className={classes.icon} color="primary" onClick={() => agregarFacturador()}>
                                    <Add />
                                </Button>
                            </Grid>

                        </Grid>
                    </Container>


                    {clienteId > 0 &&


                        <TableContainer >
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell>
                                            {/* RFC */
                                                traducirLabel(268)}
                                        </TableCell>
                                        <TableCell>
                                            {/* Razón Social */
                                                traducirLabel(253)}
                                        </TableCell>
                                        <TableCell>
                                            {/* Nombre Comercial */
                                                traducirLabel(203)}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    <TableRow >
                                        <TableCell component="th" scope="row">

                                            <Radio checked={selectedValue === clienteId}

                                                onChange={handleChange}
                                                value={clienteId}
                                                name="radio-button-demo"
                                                inputProps={{ 'aria-label': 'A' }}
                                            />
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {clienteRFC}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {clienteNombre}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {nombreComercial}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    }
                </DialogContentText>
            </DialogContent>
            <DialogActions className={classes.actions}>
                <Button variant="contained" autoFocus onClick={selectFacturador} color="primary"
                    disabled={clienteId === 0 && selectedValue === 0}>
                    {/* Continuar */
                    traducirButton(7)}
                </Button>
            </DialogActions>
        </Dialog>
        {agregaFacturador &&
            <>
                <AgregarFacturador abierto={agregaFacturador} cerrar={cerrarNuevoFacturador}
                    confirmar={cerrarNuevoFacturador} setFacturador={getFacturador}
                    ayuda={ayuda} clienteId={idCliente} usuario={usuario} empresaId={empresaId} />
            </>
        }

        {showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

    </>)
};

export default BuscarFacturador;
